<template>
	<div class="about">
		<div class="banner">
		    <img src="../static/imgs/banner.jpg" alt="">
		</div>
		<div class="about">
		    <p>中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的</p>
		    <p>中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的</p>
		    <p>中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的</p>
		    <p>中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的中国美术家协会（简称中国美协，由中共中央书记处领导，中共中央宣传部代管）是中国各民族美术家组成的人民团体，是全国政协的</p>
		</div>
	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return{
				
			}
		},
		mounted(){
			
		},
		methods:{
			
		}
	}
</script>
<style scoped>
	.banner{overflow: hidden;}
	.banner img{width:100%;height:100%;}
	.about{width:16.625rem;margin:1rem auto 0;line-height: 1.25rem;font-size: .7rem;color:#666;}
	.about p{margin-bottom: 1.2rem;}
</style>